<template>
  <div v-if="url" class="otp-page">
  <div class="otp-form">
    <h2>Kode OTP</h2>

    <div class="form-group">
      <label>OTP</label>
      <input
        v-model="otp"
        type="text"
        placeholder="Enter OTP"
      />
    </div>

    <button @click="loadDataFrame">
      Submit
    </button>
  </div>
</div>

<div v-else class="not-found-page">
  <div class="not-found-content">
    <h1>404</h1>
    <h2>Page Not Found</h2>
    <p>The page you're looking for doesn't exist or the link is invalid.</p>
  </div>
</div>
</template>

<script>
import { fnPOST, fnPOSTCore } from "../../../api/api-methods";
import { APIPATH_BBIAPPS } from "../../../api/api-paths";
export default {
  
  data() {
    return {
      iframeSrc: "",
      otp: "",
      email: "",
      url: null,
    };
  },
  methods: {

    loadDataFrame() {
      fnPOSTCore(APIPATH_BBIAPPS.listSurvey, {
        otp: this.otp,
        url: this.url,
        category: 'AOI'
        
      }).then((res) => {
        this.$router.push({ name: "SurveyAOIPage", params: { auth: 'yes' } });
      }).catch((error) => {
        alert('data otp or url not right');
      });
    }
  },
  created() {
    if (this.$route.query.url) {
      console.log(this.$route.query.url);
      this.url = this.$route.query.url
    } else {
      alert("Error url not found");
    }
    
  },
};
</script>

<style scoped>
.otp-page {
  min-height: 100vh;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
}
.otp-form {
  width: 350px;
}
h2 {
  text-align: center;
  margin-bottom: 25px;
}
h1 {
  text-align: center;
  margin-bottom: 25px;
}
.form-group {
  margin-bottom: 18px;
}
label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
}
input {
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}
button {
  width: 100%;
  padding: 11px;
  border: none;
  border-radius: 4px;
  background: #1976d2;
  color: white;
  font-size: 14px;
  cursor: pointer;
}
button:hover {
  background: #1565c0;
}
.not-found-page {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
}
</style>
